import { render, staticRenderFns } from "./ClassesFilterDropdown.vue?vue&type=template&id=65bebcf1&"
import script from "./ClassesFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClassesFilterDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports